import { Box, Flex, Text } from 'pcln-design-system'
import React from 'react'
import PackagesBadge from './PackageBadge'
import PackageRow from './PackageRow'

function PackageSection({ hasImage, packagesBadge, productProps }) {
  const { tripStartDate, tripEndDate, packageDetails } = productProps

  const parsedRows = packageDetails.map((product, index) => (
    <PackageRow {...product} key={index} id={index} />
  ))

  return (
    <Flex width={1} flexDirection='column'>
      <Flex alignItems='center' flexDirection='row'>
        {!(hasImage && packagesBadge) && (
          <Box width='100%' ml='-8px'>
            <PackagesBadge badgeText={packagesBadge} />
          </Box>
        )}
        <Flex justifyContent={hasImage ? 'start' : 'end'} width='100%'>
          <Text px={2} textStyle='subheading6'>
            {tripStartDate} - {tripEndDate}
          </Text>
        </Flex>
      </Flex>
      {parsedRows}
    </Flex>
  )
}

export default PackageSection
